import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// ANNUAL_PHYSICAL_UPDATE

const mutation = gql`
  mutation annualPhysicalFormUpdate(
    $id: ID!
    $attributes: AnnualPhysicalFormInput
    $include_mammogram: Boolean = false
    $include_pap_smear: Boolean = false
    $include_patient_name: Boolean = false
    $include_prostate_screening: Boolean = false
    $include_colon_screening: Boolean = false
    $include_smoking_attestation: Boolean = false
  ) {
    annualPhysicalFormUpdate(id: $id, annual_physical_form: $attributes) {
      id
      created_at
      employee_id
      mammogram @include(if: $include_mammogram)
      pap_smear @include(if: $include_pap_smear)
      patient_name @include(if: $include_patient_name)
      prostate_screening @include(if: $include_prostate_screening)
      colon_screening @include(if: $include_colon_screening)
      annual_smoking_attestation: smoking_attestation
        @include(if: $include_smoking_attestation)
      updated_at
    }
  }
`
export default function useAnnualFormUpdate() {
  const { onMutate: onAnnualFormUpdate, loading } = useCustomMutation({
    mutation,
    responsePath: 'annualPhysicalFormUpdate',
    successMessage: 'Annual form updated'
  })

  return { onAnnualFormUpdate, loading }
}
